import api from "./api";

export const getMyTicket = (reference) =>
  api.get(`/my-tickets/${reference}`).then((res) => res.data);
